import { Col, Form, Row } from 'antd';
import InputBase from 'components/Input';
import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import account from 'services/account';
import { validateEmail } from 'utils';
import throwException from 'utils/throwException';
import './styles.scss';

interface IProps {
  t: any;
  onRef?: (r: any) => any;
  i18n: any;
  editable?: boolean;
  org_id: string;
}

class FormAddUser extends Component<IProps> {
  componentWillUnmount() {
    const { onRef } = this.props;
    if (onRef) onRef(undefined);
  }

  handleValidateEmail = (_, v) => {
    const { t } = this.props;
    if (v && !validateEmail(v)) {
      return Promise.reject(new Error(t('login.form.input.email.format.invalid')));
    } else {
      return Promise.resolve();
    }
  };

  handleValidatePhone = (_, v) => {
    const { t } = this.props;
    if (typeof v === 'undefined' || v === '') return Promise.resolve();
    if (v.length < 9) {
      return Promise.reject(new Error(t('create.account.phone.format')));
    }
    const regexNumber = /^[0-9]+$/;

    const isNumber = (value: string): boolean => regexNumber.test(value.toLowerCase());

    const checkPhone: boolean = isNumber(v);

    if (!checkPhone) {
      return Promise.reject(new Error(t('create.account.phone.format')));
    }

    return Promise.resolve();
  };

  handleOk = (values, callback) => {
    const { org_id } = this.props;
    account
      .createUser(values, org_id)
      .then(() => {
        if (callback) callback(true);
      })
      .catch((e) => {
        throwException(e);
        if (callback) callback(false);
      });
  };

  render() {
    const { t, onRef, editable = true } = this.props;
    if (onRef) onRef(this);
    return (
      <div className="formAddLogin">
        <div style={{ fontSize: 21, fontWeight: 600, paddingBottom: 16 }}>
          {editable
            ? t('account.management.user.title.add_account')
            : t('user.management.modal.detail_new_user.title')}
        </div>
        <Row gutter={[32, 32]}>
          <Col span={12}>
            <Form.Item
              rules={[
                {
                  required: true,
                  whitespace: true,
                  message: t('user.management.modal.create_new_user.field.last_name.required'),
                },
              ]}
              name="last_name"
              label={t('user.management.modal.create_new_user.field.last_name')}
            >
              <InputBase
                disabled={!editable}
                placeholder={t('user.management.modal.create_new_user.field.last_name.placeholder')}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              rules={[
                {
                  required: true,
                  whitespace: true,
                  message: t('user.management.modal.create_new_user.field.first_name.required'),
                },
              ]}
              name="first_name"
              label={t('user.management.modal.create_new_user.field.first_name')}
            >
              <InputBase
                disabled={!editable}
                placeholder={t(
                  'user.management.modal.create_new_user.field.first_name.placeholder'
                )}
              />
            </Form.Item>
          </Col>
          
        </Row>
        <Row gutter={[32, 32]}>
          <Col span={12}>
            <Form.Item
              rules={[
                {
                  required: true,
                  whitespace: false,
                  message: t('user.management.modal.create_new_user.field.email.required'),
                },
                {
                  validator: this.handleValidateEmail,
                },
              ]}
              name="email"
              label={t('user.management.modal.create_new_user.field.email')}
            >
              <InputBase
                disabled={!editable}
                placeholder={t('user.management.modal.create_new_user.field.email.placeholder')}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              rules={[
                {
                  validator: this.handleValidateEmail,
                },
              ]}
              name="secondary_email"
              label={t('user.management.modal.create_new_user.field.secondary_email')}
              className="form-add-account"
            >
              <InputBase
                disabled={!editable}
                placeholder={t(
                  'user.management.modal.create_new_user.field.secondary_email.placeholder'
                )}
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          rules={[
            {
              validator: this.handleValidatePhone,
            },
          ]}
          name="phone"
          label={t('account.management.user_admin.table.column.phone_number')}
        >
          <InputBase
            disabled={!editable}
            placeholder={t('account.management.modal.create_new_account.field.phone_number.placeholder')}
            maxLength={12}
          />
        </Form.Item>
      </div>
    );
  }
}

export default withTranslation()(FormAddUser);
